import React from "react";

function RemoveIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="20"
            fill="none"
            viewBox="0 0 18 20"
        >
            <path
                fill="var(--color-highlight)"
                fillRule="evenodd"
                d="M6.417 3.333c0-.173.094-.408.3-.615.208-.208.444-.301.616-.301h3.334c.172 0 .408.093.615.3.207.208.301.443.301.616v.917H6.417v-.917zM5.655 5.75h8.429v10.916c0 .173-.095.409-.302.616-.207.207-.443.301-.615.301H4.833c-.172 0-.408-.094-.615-.301-.207-.207-.301-.443-.301-.616V5.75h1.738zm-.738-1.5v-.917c0-.66.322-1.258.74-1.676.418-.418 1.016-.74 1.676-.74h3.334c.66 0 1.258.322 1.676.74.418.418.74 1.016.74 1.676v.917H16.5a.75.75 0 010 1.5h-.917v10.916c0 .661-.322 1.259-.74 1.677-.418.417-1.016.74-1.676.74H4.833c-.66 0-1.258-.323-1.676-.74-.418-.418-.74-1.016-.74-1.677V5.75H1.5a.75.75 0 010-1.5h3.417zm2.416 4.166a.75.75 0 01.75.75v5a.75.75 0 01-1.5 0v-5a.75.75 0 01.75-.75zm4.084.75a.75.75 0 00-1.5 0v5a.75.75 0 101.5 0v-5z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default RemoveIcon;
